import React from 'react';
import Link from 'gatsby-link';

import Home from '../components/Home';

const IndexPage = () => <Home />;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js